(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.stickyType = this.getAttribute('data-sticky-type');
      this.currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      /*
       * Create a placeholder immediately before the Menu/Header.
       * When the Menu becomes fixed, this placeholder preserves its
       * original space so the page does not jump.
       */
      this.placeholder = document.createElement('div');
      this.placeholder.className = 'sticky-header-placeholder';
      this.placeholder.setAttribute('aria-hidden', 'true');

      if (this.parentNode) {
        this.parentNode.insertBefore(this.placeholder, this);
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);

      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        this.onResizeHandler
      );

      /*
       * Wait until layout is established before recording the Menu's
       * natural document position. This includes the Image Banner above it.
       */
      requestAnimationFrame(() => {
        this.refreshStickyPosition();
        this.onScroll();
      });

      window.addEventListener(
        'load',
        () => {
          if (!this.isSticky()) {
            this.refreshStickyPosition();
          }

          this.onScroll();
        },
        { once: true }
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

      window.removeEventListener(
        'resize',
        this.onResizeHandler
      );

      if (this.placeholder && this.placeholder.parentNode) {
        this.placeholder.parentNode.removeChild(this.placeholder);
      }
    }

    isSticky() {
      return this.classList.contains(
        'shopify-section-header-sticky'
      );
    }

    refreshStickyPosition() {
      if (this.isSticky()) return;

      const rect = this.getBoundingClientRect();

      this.stickyStart =
        rect.top +
        (window.pageYOffset || document.documentElement.scrollTop);

      this.headerHeight = this.offsetHeight;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerHeight}px`
      );

      if (this.placeholder) {
        this.placeholder.style.height = `${this.headerHeight}px`;
      }
    }

    onResize() {
      const wasSticky = this.isSticky();

      if (wasSticky) {
        this.unstick();
      }

      requestAnimationFrame(() => {
        this.refreshStickyPosition();
        this.onScroll();
      });
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (typeof this.stickyStart !== 'number') {
        this.refreshStickyPosition();
      }

      /*
       * Before the Menu reaches the top of the viewport it remains in
       * normal document flow. The Announcement Bar and Image Banner
       * therefore scroll normally.
       */
      if (scrollTop <= this.stickyStart) {
        this.classList.remove('scrolled-past-header');
        this.unstick();

        this.currentScrollTop = scrollTop;
        return;
      }

      this.classList.add('scrolled-past-header');

      /*
       * Always and reduce-logo-size:
       * Once the Menu reaches the top, keep only the Menu fixed there.
       */
      if (
        this.stickyType === 'always' ||
        this.stickyType === 'reduce-logo-size'
      ) {
        this.stick();
        this.classList.remove(
          'shopify-section-header-hidden'
        );

        this.currentScrollTop = scrollTop;
        return;
      }

      /*
       * On-scroll-up retains Dawn's reveal behavior, but it applies
       * exclusively to this Menu/Header element.
       */
      if (this.stickyType === 'on-scroll-up') {
        if (scrollTop > this.currentScrollTop) {
          if (!this.preventHide) {
            this.hide();
          }
        } else if (scrollTop < this.currentScrollTop) {
          if (!this.preventReveal) {
            this.reveal();
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            this.hide();
          }
        }
      }

      this.currentScrollTop = scrollTop;
    }

    stick() {
      if (!this.isSticky()) {
        this.headerHeight = this.offsetHeight;

        if (this.placeholder) {
          this.placeholder.style.height =
            `${this.headerHeight}px`;

          this.placeholder.classList.add('is-active');
        }

        this.classList.add(
          'shopify-section-header-sticky'
        );
      }
    }

    unstick() {
      this.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
        'scrolled-past-header'
      );

      if (this.placeholder) {
        this.placeholder.classList.remove('is-active');
      }
    }

    hide() {
      this.stick();

      this.classList.add(
        'shopify-section-header-hidden'
      );

      this.classList.remove('animate');

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.stick();

      this.classList.add('animate');

      this.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();
})();
